import { css, cva } from '@/styled-system/css';

export const accordionHeaderContentStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '{spacing.layout.default}',
  flex: 1,
});

export const accordionHeaderRecipe = cva({
  base: {
    'position': 'relative',
    'cursor': 'pointer',
    'display': 'flex',
    'alignItems': 'center',
    'gap': 'default',
    'padding': 'default',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'background-color 200ms ease, box-shadow 200ms ease',
    },
    'focusOutline': true,
    'borderTopLeftRadius': 'obj.default',
    'borderTopRightRadius': 'obj.default',

    '& .c11n_heading': {
      color: { base: 'text.neutral' },
    },

    '& > .c11n_icon': {
      color: { base: 'icon.neutral' },
      width: 'icon.sm',
      height: 'icon.sm',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        cursor: 'pointer',
        _hover: {
          '& .c11n_heading': {
            textDecoration: 'underline',
          },
        },
        _active: {
          '& .c11n_heading': {
            textDecoration: 'underline',
          },
        },
      },
    },
    expanded: {
      true: {
        backgroundColor: { base: 'Accordion.Header.bg.selected' },
      },
      false: {
        borderBottomLeftRadius: 'obj.default',
        borderBottomRightRadius: 'obj.default',
        backgroundColor: { base: 'bg.action.neutral.default' },
      },
    },
  },
  compoundVariants: [
    {
      expanded: false,
      disabled: false,

      css: {
        backgroundColor: {
          _hover: 'Accordion.Header.bg.hover',
          _active: 'Accordion.Header.bg.pressed',
        },
      },
    },
    {
      expanded: true,
      disabled: false,

      css: {
        backgroundColor: {
          _hover: 'Accordion.Header.bg.selectedHover',
          _active: 'Accordion.Header.bg.selectedPressed',
        },
      },
    },
  ],
});
